// extracted by mini-css-extract-plugin
export var bodyRow = "_fw-d";
export var cardColumns = "_fw-e";
export var ellipsesOverflow = "_fw-2";
export var flatBottomCorners = "_fw-3";
export var flatTopCorners = "_fw-4";
export var headerActionsDropdown = "_fw-f";
export var headerBottomRow = "_fw-c";
export var headerTopRow = "_fw-b";
export var orderDetailsWrapper = "_fw-0";
export var orderInfoContainer = "_fw-1";
export var productDetails = "_fw-9";
export var productImage = "_fw-5";
export var responsiveTable = "_fw-8";
export var shipmentContainer = "_fw-a";
export var tableBottomLeft = "_fw-6";
export var tableBottomRight = "_fw-7";